<template>
    <div class="content filayout">
        <div class="content f_layout">
            <div class="layoutbox" v-for="(board, index) in boardData" :key="`business${board.wr_id}`"  @click="goDetail(board.wr_id)">
                <div class="layout_image" :style="`background-image:url(${returnImage(board)})`"></div>
                <div class="layout_text">{{board.wr_subject}}</div>
            </div>
        </div>
    </div>
</template>

<script>
    import util from "@/mixins/util";
    import imageOption from "@/mixins/imageOption";
    export default {
        name: "BoardListFinancialLayout",
        mixins: [imageOption],

        components: {},
        props: {
            boardData: {
                type: Array,
                default: () => {
                    return []
                }
            },
        },
        data() {
            return {}
        },
        beforeRouterEnter() {
        },
        created() {
        },
        mounted() {

        },
        beforeDestroy() {
        },
        destroyed() {
        },
        computed: {},
        methods: {
            goDetail(idx) {
                this.$router.push(`/financial/${idx}?tab=financial`)
            },
            returnImage(data) {
                if (this.hasFile(data)) {
                    return `${data.File.File[0].org_url}?${this.setImageOptions(204, 204, 'jpg')}`
                }
                else { return ''}
            },
            hasFile(data) {
                return !util.isEmpty(data.File) && data.File.hasOwnProperty('File') && !util.isEmpty(data.File.File)
            },
        },
        watch: {},
    }
</script>

<style scoped>

</style>